<div class="change-password-page">
    <div class="change-password-wrap">
        <img
            class="change-password-logo"
            alt="HOMER - Health Operations & Medical Emergency Response"
            src="assets/images/logos/logo.png"
        />

        <div class="change-password-card rounded bg-light border">
            <div class="p-4">
                @if (!isExpired) {
                    <form
                        (ngSubmit)="onSubmit()"
                        [formGroup]="changePasswordForm"
                    >
                        <div class="mb-3">
                            <pcg-show-hide-password
                                fcName="password"
                                [parentForm]="changePasswordForm"
                                label="New Password"
                                inputCssClass="form-control"
                                [validations]='{ "commonPassword": "Pick a less common password.", "sequentialChars" : "Password cannot contain more than 2 sequential characters."  }'
                            ></pcg-show-hide-password>
                        </div>

                        <div class="mb-3">
                            <pcg-show-hide-password
                                fcName="confirmPassword"
                                [parentForm]="changePasswordForm"
                                label="Confirm New Password"
                                inputCssClass="form-control"
                                [validations]='{ "passwordsNotEqual": "Passwords do not match." }'
                            ></pcg-show-hide-password>
                        </div>

                        <p-button
                            class="w-100"
                            type="submit"
                            label="Set Password"
                            styleClass="w-100"
                            raised
                            severity="info"
                        />
                    </form>

                    <div class="text-muted small mt-3">
                        <div class="fw-bold mb-1">Password requirements</div>
                        Must be at least 10 characters in length.<br />
                        Cannot contain more than 2 sequential characters.<br />
                        Cannot match a commonly used password.
                    </div>
                } @else {
                    <div class="text-danger text-center">{{ errorMessage }}</div>
                }
            </div>
        </div>
    </div>
</div>
